import {decodeAccessToken} from '@resurs-internal/core/lib/jwt';
import {useMemo} from 'react';
import {AccessToken} from '../../model';
import {useAuthGlobalState} from '../useAuthState/useAuthGlobalState';

export const useAuthToken: () => AccessToken | undefined = () => {
  const auth = useAuthGlobalState();
  return useMemo(() => {
    if (auth.state.token) return decodeAccessToken(auth.state.token);
    return undefined;
  }, [auth.state.token]);
};

export default useAuthToken;
